<template>
  <div class="mainTableBox">
    <el-row class="mpadding" :gutter="12">
      <div style="width:100%">数据总览       
        <el-button
          style="float:right"
          type="danger"
          :loading="loadingexport" @click="doExportSale"
          v-hasPermission="['report:sale:export']"
          >{{loadingexport ? "导出中 ..." : "导出数据"}}</el-button></div>  
      <el-divider style="margin-top:10px" />
      <div class="searchBox">
        <div style="float:left">
          <span style="float:left;height:30px;line-height:30px">统计时间：</span>
          <el-date-picker
            style="width:210px"
            ref="dateRef"
            v-if="isShowDate"
            v-model="queryParam.date"
            type="daterange"
            unlink-panels
            range-separator="To"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="showDate"
          />
          <el-date-picker
            style="width:230px"
            ref="date1Ref"
            v-if="isShowDate1"
            v-model="queryParam.date1"
            :type="dateType"
            placeholder="选择日期"
            @change="showDate"
          />

          <el-date-picker
            style="width:230px"
            ref="date2Ref"
            v-if="isShowDate2"
            v-model="queryParam.date1"
            type="week"
            :format="queryParam.start+' To '+queryParam.end"
            placeholder="选择周"
            @change="showDate"
          />
        </div>
        <el-radio-group style="vertical-align:4px;margin:0 10px;float: left;">
          <el-radio-button :class="[dateTab=='yesterday' ? 'active' : '']" label="yesterday" @click.prevent="doDateClick('yesterday')">昨日</el-radio-button>
          <el-radio-button :class="{ active: dateTab=='sevenday' }" label="sevenday" @click.prevent="doDateClick('sevenday')">近7日</el-radio-button>
          <el-radio-button :class="{ active: dateTab=='thirtyday' }" label="thirtyday" @click.prevent="doDateClick('thirtyday')">近30日</el-radio-button>
          <el-radio-button :class="{ active: dateTab=='day' }" label="day" @click.prevent="doDateClick('day')">日</el-radio-button>
          <el-radio-button :class="{ active: dateTab=='week' }" label="week" @click.prevent="doDateClick('week')">周</el-radio-button>
          <el-radio-button :class="{ active: dateTab=='month' }" label="month" @click.prevent="doDateClick('month')">月</el-radio-button>
          <el-radio-button :class="{ active: dateTab=='year' }" label="year" @click.prevent="doDateClick('year')">年</el-radio-button>
          <el-radio-button :class="{ active: dateTab=='diy' }" label="diy" @click.prevent="doDateClick('diy')">自定义</el-radio-button>
        </el-radio-group>
        <el-select v-model="queryParam.customerid" multiple filterable placeholder="选择客户" @change="doCustomerClick" style="width:150px;float: left;">
          <template v-for="item in customerData" :key="item.customerid">
            <el-option :label="item.name" :value="item.customerid" />
          </template>
        </el-select>
        <el-select v-model="queryParam.supplierid" multiple filterable placeholder="选择供应商" @change="doSupplierClick" style="width:150px;float: left;">
          <template v-for="item in supplierData" :key="item.supplierid">
            <el-option :label="item.name" :value="item.supplierid" />
          </template>
        </el-select>
        <el-select v-model="queryParam.typeid" multiple filterable placeholder="选择商品类型" @change="doGoodsTypeClick" style="width:150px;float: left;">
          <template v-for="item in goodsTypeData" :key="item.typeid">
            <el-option :label="item.typename" :value="item.typeid" />
          </template>
        </el-select>
        <!-- <el-radio-group style="vertical-align:4px;margin:0 10px;float: left;">
          <el-radio-button :class="[customerType=='1' ? 'active' : '']" label="1" @click.prevent="doCutomerTypeClick('1')">积分客户</el-radio-button>
          <el-radio-button :class="[customerType=='2' ? 'active' : '']" label="2" @click.prevent="doCutomerTypeClick('2')">电商客户</el-radio-button>
          <el-radio-button
          :class="[customerType == '3' ? 'active' : '']"
          label="3"
          @click.prevent="doCutomerTypeClick('3')"
          >其他客户</el-radio-button
        >
        </el-radio-group> -->
        <el-button @click="resetSearch">重置</el-button>
      </div>

      <el-col :span="4">
        <el-card class="blockOption" :class="[cardType=='saleamount' ? 'active' : '']" @click="getCardType('saleamount')">
          <h1>销售总额</h1>
          <div class="amount">{{totalreport.saleamount}}</div>
          <div class="process">
            <span class="title">环比</span>
            <span class="content" :class="[(totalreport.saleamountRatio).indexOf('-')!=-1?'low':'']"> <img :src="(totalreport.saleamountRatio).indexOf('-')!=-1?blueImg:redImg" />{{ (totalreport.saleamountRatio).indexOf('-')!=-1?'':'+'}} {{totalreport.saleamountRatio}}</span>
          </div>
          <div class="active">
            <div style="position: relative">
              <div style="position: absolute; top: -16px">
                <span
                  role="img"
                  aria-label="check"
                  class="anticon anticon-check"
                  ><svg
                    viewBox="64 64 896 896"
                    focusable="false"
                    data-icon="check"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                    ></path></svg></span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card class="blockOption" :class="[cardType=='costamount' ? 'active' : '']" @click="getCardType('costamount')">
          <h1>成本总额</h1>
          <div class="amount">{{totalreport.costamount}}</div>
          <div class="process">
            <span class="title">环比</span>
            <span class="content" :class="[(totalreport.costamountRatio).indexOf('-')!=-1?'low':'']"> <img :src="(totalreport.costamountRatio).indexOf('-')!=-1?blueImg:redImg" />{{ (totalreport.costamountRatio).indexOf('-')!=-1?'':'+'}} {{totalreport.costamountRatio}}</span>
          </div>
          <div class="active">
            <div style="position: relative">
              <div style="position: absolute; top: -16px">
                <span
                  role="img"
                  aria-label="check"
                  class="anticon anticon-check"
                  ><svg
                    viewBox="64 64 896 896"
                    focusable="false"
                    data-icon="check"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                  <path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg></span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card class="blockOption" :class="[cardType=='ordertotal' ? 'active' : '']" @click="getCardType('ordertotal')">
          <h1>订单总数</h1>
          <div class="amount">{{totalreport.orderqty}}</div>
          <div class="process">
            <span class="title">环比</span>
            <span class="content" :class="[(totalreport.orderqtyRatio).indexOf('-')!=-1?'low':'']"> <img :src="(totalreport.orderqtyRatio).indexOf('-')!=-1?blueImg:redImg" />{{ (totalreport.orderqtyRatio).indexOf('-')!=-1?'':'+'}} {{totalreport.orderqtyRatio}}</span>
          </div>
          <div class="active">
            <div style="position: relative">
              <div style="position: absolute; top: -16px">
                <span
                  role="img"
                  aria-label="check"
                  class="anticon anticon-check"
                  ><svg
                    viewBox="64 64 896 896"
                    focusable="false"
                    data-icon="check"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                    ></path></svg></span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="4">
        <el-card class="blockOption" :class="[cardType=='saleCusstatusUnverifiedamount' ? 'active' : '']" @click="getCardType('saleCusstatusUnverifiedamount')">
          <h1>客户未对账总额</h1>
          <div class="amount">{{totalreport.saleamountCusstatusUnverified}}</div>
          <div class="process">
            <span class="title">环比</span>
            <span class="content" :class="[(totalreport.saleamountCusstatusUnverifiedRatio).indexOf('-')!=-1?'low':'']"> <img :src="(totalreport.saleamountCusstatusUnverifiedRatio).indexOf('-')!=-1?blueImg:redImg" />{{ (totalreport.saleamountCusstatusUnverifiedRatio).indexOf('-')!=-1?'':'+'}} {{totalreport.saleamountCusstatusUnverifiedRatio}}</span>
          </div>
          <div class="active">
            <div style="position: relative">
              <div style="position: absolute; top: -16px">
                <span
                  role="img"
                  aria-label="check"
                  class="anticon anticon-check"
                  ><svg
                    viewBox="64 64 896 896"
                    focusable="false"
                    data-icon="check"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg></span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="4">
        <el-card class="blockOption" :class="[cardType=='maolieamount' ? 'active' : '']" @click="getCardType('maolieamount')">
          <h1>毛利额</h1>
          <div class="amount">{{totalreport.maolieamount}}</div>
          <div class="process">
            <span class="title">环比</span>
            <span class="content" :class="[(totalreport.maolieamountRatio).indexOf('-')!=-1?'low':'']"> <img :src="(totalreport.maolieamountRatio).indexOf('-')!=-1?blueImg:redImg" />{{ (totalreport.maolieamountRatio).indexOf('-')!=-1?'':'+'}} {{totalreport.maolieamountRatio}}</span>
          </div>
          <div class="active">
            <div style="position: relative">
              <div style="position: absolute; top: -16px">
                <span
                  role="img"
                  aria-label="check"
                  class="anticon anticon-check"
                  ><svg
                    viewBox="64 64 896 896"
                    focusable="false"
                    data-icon="check"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg></span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card class="blockOption" :class="[cardType=='maoliv' ? 'active' : '']" @click="getCardType('maoliv')">
          <h1>毛利率</h1>
          <div class="amount">{{totalreport.maolivamount}}</div>
          <!-- <div class="amount" v-if="totalreport.orderqty>0">{{((totalreport.maolivamount/totalreport.orderqty)).toFixed(2)}}</div>
          <div class="amount" v-else>0</div> -->
          <div class="process">
            <span class="title">环比</span>
            <span class="content" :class="[(totalreport.maolivamountRatio).indexOf('-')!=-1?'low':'']"> <img :src="(totalreport.maolivamountRatio).indexOf('-')!=-1?blueImg:redImg" />{{ (totalreport.maolivamountRatio).indexOf('-')!=-1?'':'+'}} {{totalreport.maolivamountRatio}}</span>
          </div>
          <div class="active">
            <div style="position: relative">
              <div style="position: absolute; top: -16px">
                <span
                  role="img"
                  aria-label="check"
                  class="anticon anticon-check"
                  ><svg
                    viewBox="64 64 896 896"
                    focusable="false"
                    data-icon="check"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"></path></svg></span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <div id="mychart" :style="{ width: '100%', height: '450px', textAlign: 'center' }">正在生成图表中...</div>
    </el-row>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
import dayjs from "dayjs";
import { getReportSale,exportSale } from "@/api/report";

import { listCustomerCache } from "@/api/customer";
import { listSupplierCache } from "@/api/supplier";
import { listGoodsTypeCache } from "@/api/goodstype";


const totalreport = ref({
  saleamount:0,
  saleamountRatio:'0%',
  costamount:0,
  costamountRatio:'0%',
  maolieamount:0,
  maolieamountRatio:'0%',
  maolivamount:0,
  maolivamountRatio:'0%',
  orderqty:0,
  orderqtyRatio:'0%',
  saleamountCusstatusUnverified:0,
  saleamountCusstatusUnverifiedRatio:'0%'
})

const redImg = ref(
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGBAMAAAAMK8LIAAAAGFBMVEUAAAD2Vlb2Vlb2Vlb2Vlb2Vlb2Vlb2VlbXo6FSAAAAB3RSTlMA1PeraC0PSuR7zgAAACJJREFUCNdjYEgUY2BgMC9mYGApL3dgCCovV2UQLy8vBBMAT7AGpRb27cMAAAAASUVORK5CYII="
);
const blueImg = ref(
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGBAMAAAAMK8LIAAAAGFBMVEUAAAA+zPs+zPs+zPs+zPs+zPs+zPs+zPtahgkWAAAAB3RSTlMA1PeraC0PSuR7zgAAACFJREFUCNdjEC8vL4QQQeXlqgws5eUODAzmxQwMDIliDAB1igaloR9NFAAAAABJRU5ErkJggg=="
);

const dateRef = ref()
const date1Ref = ref()
const date2Ref = ref()

const dateType = ref('date')
const customerType = ref('');
const dateTab = ref('day')
const isShowDate = ref(false)
const isShowDate1 = ref(true)
const isShowDate2 = ref(false)

const cardType = ref('saleamount')

const queryParam = ref({
  customerid: '',
  supplierid: '',
  typeid: '',
  date: [],
  date1: '',
  start:'',
  end: '',  
})

const resetSearch = () => {
  customerType.value = ''

  const start = new Date()
  dateTab.value = 'day'
  isShowDate.value =  isShowDate2.value =  false
  isShowDate1.value = true
  dateType.value = 'date'
  queryParam.value.date = []
  queryParam.value.date1 = dayjs(start).format("YYYY-MM-DD")

  getReportSaleData()
}

const doDateClick = (flag)=> {
  const start = new Date()
  const end = new Date()
  dateTab.value = flag
  if (flag == 'yesterday') {
    start.setTime(start.getTime() - 3600 * 1000 * 24)
    queryParam.value.date =  [start, start]
    isShowDate1.value = isShowDate2.value = false
    isShowDate.value = true
  } else if (flag == 'sevenday') {
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
    end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
    queryParam.value.date =  [start, end]
    isShowDate1.value = isShowDate2.value = false
    isShowDate.value = true
  }  else if (flag == 'thirtyday') { 
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
    queryParam.value.date =  [start, end]
    isShowDate1.value =  isShowDate2.value = false
    isShowDate.value = true
  } else if (flag == 'day') {
    isShowDate.value =  isShowDate2.value =  false
    isShowDate1.value = true
    dateType.value = 'date'
    queryParam.value.date = []
    queryParam.value.date1 = dayjs(start).format("YYYY-MM-DD")
    // date1Ref.value.focus()
  } else if (flag == 'week') {
    isShowDate.value = isShowDate1.value = false
    isShowDate2.value = true
    dateType.value = 'week'
    queryParam.value.date = []

    queryParam.value.date1 = dayjs().day(1).$d
    console.log('queryParam.value.date1----weeek:', dayjs().day(1).$d)


    let startTime = dayjs(queryParam.value.date1).subtract(0, "day").$d;
    let endTime = dayjs(startTime).add(6, "day").$d;

    queryParam.value.start = dayjs(startTime).format("YYYY-MM-DD")
    queryParam.value.end = dayjs(endTime).format("YYYY-MM-DD")

    console.log('queryParam.value.start:',dayjs().day(1))
    // console.log('queryParam.value.end:',queryParam.value.end)
    // date2Ref.value.focus()
  } else if (flag == 'month') {
    isShowDate.value =  isShowDate2.value =  false
    isShowDate1.value = true
    dateType.value = 'month'
    queryParam.value.date = []
    queryParam.value.date1 = dayjs(start).format("YYYY-MM")

    // date1Ref.value.focus()
  } else if (flag == 'year') {
    isShowDate.value = isShowDate2.value =  false
    isShowDate1.value = true
    dateType.value = 'year'
    queryParam.value.date = []
    queryParam.value.date1 = dayjs(start).format("YYYY")
    // date1Ref.value.focus()
  } else if (flag == 'diy') {
    isShowDate1.value = isShowDate2.value = false
    isShowDate.value = true
    queryParam.value.date =  [dayjs().startOf("month").format("YYYY-MM-DD"), dayjs().endOf("month").format("YYYY-MM-DD")]
    // dateRef.value.focus()
  }
  getReportSaleData()
}

// const doCutomerTypeClick = (flag) => {
//   customerType.value = flag
//   queryParam.value.customerid = ""
//   getReportSaleData()
// }

const doCustomerClick = ()=> {
  customerType.value = ""
  getReportSaleData()
}

const doSupplierClick = ()=> {
  getReportSaleData()
}

const doGoodsTypeClick = ()=> {
  getReportSaleData()
}


const showDate = () => {
    console.log('queryParam.value.date:',queryParam.value.date)
    console.log('queryParam.value.start:',queryParam.value.date1)

    if (dateTab.value == 'week') {

      console.log('000',queryParam.value.date1,'-------',dayjs(queryParam.value.date1).week())
      console.log('000-------2022-10-10',dayjs('2022-10-10').week())
      console.log('000-------2022-10-22',dayjs('2022-10-22').week())
      let startTime = dayjs(queryParam.value.date1).subtract(0, "day").$d;
      let endTime = dayjs(startTime).add(6, "day").$d;
      
      queryParam.value.start = dayjs(startTime).format("YYYY-MM-DD")
      queryParam.value.end = dayjs(endTime).format("YYYY-MM-DD")
    }
    getReportSaleData()
}


const eChartReport = ref({
  echartSaleamount:[],
  echartCostamount:[],
  echartQtyamount: [],
  echartMaolieamount: [],
  echartMaolivamount: [],
  echartSaleCusstatusUnverifiedamount: []
});

const getCardType = (flag) => {
  cardType.value = flag
  //getReportSaleData()
  if (cardType.value === 'saleamount') {
        createChart(eChartReport.value.echartSaleamount,'销售总额')
      } else if (cardType.value === 'costamount') {
        createChart(eChartReport.value.echartCostamount,'成本总额')
      } else if (cardType.value === 'ordertotal') {
        createChart(eChartReport.value.echartQtyamount,'订单总数')
      } else if (cardType.value === 'maolieamount') {
        createChart(eChartReport.value.echartMaolieamount,'毛利额')
      } else if (cardType.value === 'maoliv') {
        createChart(eChartReport.value.echartMaolivamount,'毛利率')
      } else if (cardType.value === 'saleCusstatusUnverifiedamount') {
        createChart(eChartReport.value.echartSaleCusstatusUnverifiedamount,'客户未对帐总额')
      } 
}

let myChart;


const getReportSaleData = () => {
  if (myChart != null && myChart != "" && myChart != undefined) {
    myChart.dispose(); //销毁
  }

  let data = {
    datetype: '',
    start:'',
    end:'',
    cardtype: 'saleamount',
    customerid: '',
    supplierid: '',
    typeid: '',
    customertype: ''
  }

  data.datetype = dateTab.value
  data.cardtype = cardType.value
  data.customerid = queryParam.value.customerid
  data.supplierid = queryParam.value.supplierid
  data.typeid = queryParam.value.typeid
  data.customertype = customerType.value

  if (dateTab.value === 'yesterday' || dateTab.value === 'sevenday' || dateTab.value === 'thirtyday') {
    data.start = dayjs(queryParam.value.date[0]).format("YYYY-MM-DD")
    data.end = dayjs(queryParam.value.date[1]).format("YYYY-MM-DD")
  } else if (dateTab.value === 'day') {
    let tmp = dayjs(queryParam.value.date1).format("YYYY-MM-DD")
    data.start = tmp
    data.end = tmp
  } else if (dateTab.value === 'week') {
    data.start = queryParam.value.start
    data.end = queryParam.value.end
  } else if (dateTab.value === 'month') {
    let tmp = dayjs(queryParam.value.date1).format("YYYY-MM")
    // let monthnum = dayjs(tmp+'-01').daysInMonth()
    // data.start = tmp+'-01'
    // data.end = tmp+'-'+monthnum
    data.start = tmp
  } else if (dateTab.value === 'year') {
    let tmp = dayjs(queryParam.value.date1).format("YYYY")
    // data.start = tmp+'-01-01'
    // data.end = tmp+'-12-31'
    data.start = tmp
  } else if (dateTab.value === 'diy') {
    data.start = dayjs(queryParam.value.date[0]).format("YYYY-MM-DD")
    data.end = dayjs(queryParam.value.date[1]).format("YYYY-MM-DD")
  }
  console.log('data--------',data)

  let query = JSON.parse(JSON.stringify(data)); 
  query.customerids = data.customerid?data.customerid.join(','):''
  delete query.customerid

  query.supplierids = data.supplierid?data.supplierid.join(','):''
  delete query.supplierid

  query.typeids = data.typeid?data.typeid.join(','):''
  delete query.typeid

  console.log(query)

  getReportSale(query).then((res) => {//data
      console.log(res.data)
      let rdata = res.data.extend
      totalreport.value = rdata.report
      if (cardType.value === 'saleamount') {
        createChart(rdata.echartSaleamount,'销售总额')
      } else if (cardType.value === 'costamount') {
        createChart(rdata.echartCostamount,'成本总额')
      } else if (cardType.value === 'ordertotal') {
        createChart(rdata.echartQtyamount,'订单总数')
      } else if (cardType.value === 'maolieamount') {
        createChart(rdata.echartMaolieamount,'毛利额')
      } else if (cardType.value === 'maoliv') {
        createChart(rdata.echartMaolivamount,'毛利率')
      } else if (cardType.value === 'saleCusstatusUnverifiedamount') {
         createChart(rdata.echartSaleCusstatusUnverifiedamount,'客户未对帐总额')
      }
      eChartReport.value = {
        echartSaleamount: rdata.echartSaleamount,
        echartCostamount: rdata.echartCostamount,
        echartQtyamount: rdata.echartQtyamount,
        echartMaolieamount: rdata.echartMaolieamount,
        echartMaolivamount: rdata.echartMaolivamount,
        echartSaleCusstatusUnverifiedamount: rdata.echartSaleCusstatusUnverifiedamount
      }
  });
}


const createChart = (xydata,title) => {
  let xdata =  Object.keys(xydata)
  let ydata = Object.values(xydata)
  myChart = echarts.init(document.getElementById("mychart"));
  // 绘制图表
  myChart.setOption({
    // title: { text: "总用户量" },
    tooltip: {},
    xAxis: {
      data: xdata,
    },
    yAxis: {},
    series: [
      {
        name: title,
        type: "line",
        smooth: true,
        data: ydata,
      },
    ],
  });
  window.onresize = function () {
    //自适应大小
    myChart.resize();
  };
};

let timer;
const loadingexport = ref(false)
const doExportSale = () => {
  let data = {
    datetype: '',
    start:'',
    end:'',
    cardtype: 'saleamount',
    customerid: '',
    supplierid: '',
    typeid: '',
    customertype: ''
  }

  data.datetype = dateTab.value
  data.cardtype = cardType.value
  data.customerid = queryParam.value.customerid
  data.supplierid = queryParam.value.supplierid
  data.typeid = queryParam.value.typeid
  data.customertype = customerType.value

  if (dateTab.value === 'yesterday' || dateTab.value === 'sevenday' || dateTab.value === 'thirtyday') {
    data.start = dayjs(queryParam.value.date[0]).format("YYYY-MM-DD")
    data.end = dayjs(queryParam.value.date[1]).format("YYYY-MM-DD")
  } else if (dateTab.value === 'day') {
    let tmp = dayjs(queryParam.value.date1).format("YYYY-MM-DD")
    data.start = tmp
    data.end = tmp
  } else if (dateTab.value === 'week') {
    data.start = queryParam.value.start
    data.end = queryParam.value.end
  } else if (dateTab.value === 'month') {
    let tmp = dayjs(queryParam.value.date1).format("YYYY-MM")
    // let monthnum = dayjs(tmp+'-01').daysInMonth()
    // data.start = tmp+'-01'
    // data.end = tmp+'-'+monthnum
    data.start = tmp
  } else if (dateTab.value === 'year') {
    let tmp = dayjs(queryParam.value.date1).format("YYYY")
    // data.start = tmp+'-01-01'
    // data.end = tmp+'-12-31'
    data.start = tmp
  } else if (dateTab.value === 'diy') {
    data.start = dayjs(queryParam.value.date[0]).format("YYYY-MM-DD")
    data.end = dayjs(queryParam.value.date[1]).format("YYYY-MM-DD")
  }
  console.log('data--------',data)
  let query = JSON.parse(JSON.stringify(data)); 
  query.customerids = data.customerid?data.customerid.join(','):''
  delete query.customerid

  query.supplierids = data.supplierid?data.supplierid.join(','):''
  delete query.supplierid

  query.typeids = data.typeid?data.typeid.join(','):''
  delete query.typeid

  console.log(query)
  loadingexport.value = true;
  exportSale(query).then((response) => {//data
      downloadExcel(response);
    });
};

const downloadExcel = (response) => {
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      loadingexport.value = false;
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }, 1000);
  console.log(timer);
};


//客户列表API
const customerData = ref([]);
const customerReset = (customers) => {
  let dataTmp = [];
  customers.forEach((customer) => {
    customer.customerid = customer.customerid.toString();
    dataTmp.push(customer);
  });
  return dataTmp;
};
const getListCustomer = () => {
  listCustomerCache({ pageNo: 1, pageSize: 1000, status: 1 }).then((res) => {
    customerData.value = customerReset(res.data.extend.pages.list);
  });
};

//供应商列表API
const supplierData = ref([]);
const supplierReset = (suppliers) => {
  let dataTmp = [];
  suppliers.forEach((supplier) => {
    supplier.supplierid = supplier.supplierid.toString();
    dataTmp.push(supplier);
  });
  return dataTmp;
};
const getListSupplier = () => {
  listSupplierCache({ pageNo: 1, pageSize: 1000, status: 1 }).then((res) => {
    supplierData.value = supplierReset(res.data.extend.pages.list);
  });
};

//商品类型列表API
const goodsTypeData = ref([]);
const goodsTypeReset = (goodsTypes) => {
  let dataTmp = [];
  goodsTypes.forEach((goodsType) => {
    goodsType.typeid = goodsType.typeid.toString();
    dataTmp.push(goodsType);
  });
  return dataTmp;
};
const getListGoodsType = () => {
  listGoodsTypeCache({ pageNo: 1, pageSize: 1000, status: 1 }).then((res) => {
    goodsTypeData.value = goodsTypeReset(res.data.extend.pages.list);
  });
};

onMounted(() => {
  const start = new Date()
  //昨天为默认
  // start.setTime(start.getTime() - 3600 * 1000 * 24)
  // queryParam.value.date =  [start, start]
  //今日为默认
  start.setTime(start.getTime())
  queryParam.value.date1 =  start
  
  getListCustomer()
  getListSupplier()
  getListGoodsType()
  getReportSaleData()
});
</script>
<style>
.searchBox {
  display: block; margin-bottom: 30px;width:100%;
}
.searchBox .el-radio-button__inner {
  padding: 8px 12px;
}
.searchBox .active .el-radio-button__inner {
  color:#f65656
}
.blockOption {
  border: none;
  font-family: DINAlternate-Bold;
  background: #f5f8fc;
  position: relative;
  border-radius: 10px;
  cursor: pointer;
}
.blockOption.active {
  background: rgb(255, 255, 255);
  border: 2px solid rgb(81, 92, 255);
  box-shadow: rgb(61 89 216 / 31%) 0px 2px 13px 0px;
}
.blockOption h1 {
  color: #909399;
  font-size: 14px;
  font-weight: normal;
}
.blockOption .amount {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}
.blockOption .process > .title {
  color: #909399;
  font-size: 14px;
  font-weight: normal;
  padding-right: 10px;
}
.blockOption .process > .content {
  color: #f65656;
  font-size: 16px;
  font-weight: normal;
}
.blockOption .process > .content.low {
  color: #3eccfb;
}
.blockOption .process > .content img {
  padding-right: 5px;
}
.blockOption.active .active {
  display: block;
}

.blockOption .active {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  color: #fff;
  font-size: 14px;
  line-height: 18px;
  border-color: #515cff #515cff transparent transparent;
  border-style: solid;
  border-width: 18px;
}

.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>